// Monaco appends one screen-reader live region to document.body, outside the
// BB Config Editor's masked page root, and announces find results there with
// the matching source line. Session replay (LogRocket) records nothing inside
// a data-private element, so the region is masked as soon as it is inserted.
//
// Browsers notify mutation observers in the order they were created. Install
// this before LogRocket.init so the recorder's observer, created later, only
// ever sees the region with data-private already set. The observer stays
// registered for the app's lifetime; Monaco runs only under /bb-config, and
// each body child change costs one selector match per added node.
const LIVE_REGION_SELECTOR = '.monaco-aria-container';

const mask = (node) => node.setAttribute('data-private', '');

export function installMonacoLiveRegionMask() {
  document.querySelectorAll(LIVE_REGION_SELECTOR).forEach(mask);
  const observer = new MutationObserver((records) => {
    records.forEach(({addedNodes}) => addedNodes.forEach((node) => {
      if (node.nodeType === Node.ELEMENT_NODE && node.matches(LIVE_REGION_SELECTOR)) mask(node);
    }));
  });
  observer.observe(document.body, {childList: true});
  return observer;
}
